import { pipe } from 'fp-ts/lib/function';
import joi from 'joi';
import { discoveryTasks } from '../discoveryTasks';
import { nonEmptyArray } from '../types';

export type DiscoveryTaskId = (typeof discoveryTasks)[number]['id'];

export interface DiscoveryTask {
  id?: string;
  family: string | null;
  label: string;
  model: string | null;
  platform: string | null;
  sn: string | null;
  taskId: DiscoveryTaskId;
  vendor: string | null;
  version: string | null;
}

export const discoveryTaskIds = pipe(
  discoveryTasks,
  nonEmptyArray.map(({ id }) => id),
);

export const discoveryTaskSchema = joi.object().keys({
  id: joi.string(),
  family: joi.string().allow(null).required(),
  label: joi.string().allow('').required(),
  model: joi.string().allow(null).required(),
  platform: joi.string().allow(null).required(),
  sn: joi.string().allow(null).required(),
  taskId: joi
    .string()
    .valid(...discoveryTaskIds)
    .required(),
  vendor: joi.string().allow(null).required(),
  version: joi.string().allow(null).required(),
});

export type DbDiscoveryTask = Required<DiscoveryTask>;

export const dbDiscoveryTaskSchema = discoveryTaskSchema.fork(
  ['id'],
  (schema) => schema.required(),
);
